import { createFileRoute, redirect } from '@tanstack/react-router';

import { UserRoles } from '~entities/users';

import { PushNotificationPage } from '~features/mobile-inventor-push/push-notification-page';

import { checkMinRoleValue } from '~shared/utils/role-guard';

export const Route = createFileRoute(
  '/_auth/_layout/mobile-inventor-integration',
)({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.ADMIN);
    if (!hasAccess) {
      return redirect({
        to: '/dashboard',
      });
    }
  },
  component: PushNotificationPage,
});
